import Logo from '../../../assets/logo/logo.png'

const Round = props => {
    return <div className='countainer fluid py-2'>
        <div className="container fluid">
            <p className="text xl"><a href="#rounded" className="link">&#128279;</a> Rounded</p>
            <p className="text md">
                Rounded classes applies different <code>border-radius</code> properties to a HTML element.
                        </p>
        </div>

        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.rounded-sm, .rounded-md, .rounded-lg, .rounded-xl, .rounded-circle</code>
                            </td>
                            <td>Modifies border radius</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Border radius</label>
                                    <select onChange={(e) => props.helper('rounded-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rounded-sm">.rounded-sm</option>
                                        <option value="rounded-md">.rounded-md</option>
                                        <option value="rounded-lg">.rounded-lg</option>
                                        <option value="rounded-xl">.rounded-xl</option>
                                        <option value="rounded-circle">.rounded-circle</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.rounded-sm-rt, .rounded-sm-lt, .rounded-sm-rb, .rounded-sm-lb,</code>
                            </td>
                            <td>Modifies border radius on 3 specific tips</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Border radius</label>
                                    <select onChange={(e) => props.helper('rounded-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rounded-sm-rt">.rounded-sm-rt</option>
                                        <option value="rounded-sm-lt">.rounded-sm-lt</option>
                                        <option value="rounded-sm-rb">.rounded-sm-rb</option>
                                        <option value="rounded-sm-lb">.rounded-sm-lb</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.rounded-md-rt, .rounded-md-lt, .rounded-md-rb, .rounded-md-lb,</code>
                            </td>
                            <td>Modifies border radius on 3 specific tips</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Border radius</label>
                                    <select onChange={(e) => props.helper('rounded-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rounded-md-rt">.rounded-md-rt</option>
                                        <option value="rounded-md-lt">.rounded-md-lt</option>
                                        <option value="rounded-md-rb">.rounded-md-rb</option>
                                        <option value="rounded-md-lb">.rounded-md-lb</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.rounded-lg-rt, .rounded-lg-lt, .rounded-lg-rb, .rounded-lg-lb,</code>
                            </td>
                            <td>Modifies border radius on 3 specific tips</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Border radius</label>
                                    <select onChange={(e) => props.helper('rounded-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rounded-lg-rt">.rounded-lg-rt</option>
                                        <option value="rounded-lg-lt">.rounded-lg-lt</option>
                                        <option value="rounded-lg-rb">.rounded-lg-rb</option>
                                        <option value="rounded-lg-lb">.rounded-lg-lb</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.rounded-xl-rt, .rounded-xl-lt, .rounded-xl-rb, .rounded-xl-lb,</code>
                            </td>
                            <td>Modifies border radius on 3 specific tips</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Border radius</label>
                                    <select onChange={(e) => props.helper('rounded-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value="rounded-xl-rt">.rounded-xl-rt</option>
                                        <option value="rounded-xl-lt">.rounded-xl-lt</option>
                                        <option value="rounded-xl-rb">.rounded-xl-rb</option>
                                        <option value="rounded-xl-lb">.rounded-xl-lb</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container sm">
            <div className="border-dark min-h25 align-items-center justify-content-center">
                <img src={Logo} alt="POKE-CSS-LOGO" style={{ width: '100px', height: '100px' }} id="rounded-display" />
            </div>
        </div>
    </div>
}

export default Round